<template>
    <v-dialog content-class="news" v-model="getNewsletter" persistent>
        <v-container style="background:#ffffff;" class="test">
            <v-row style="margin: 10px">
                <v-col cols="12" align="right" class="ma-0 pa-0">
                  <v-btn text @click="setNewsletter(false)"><v-icon color="black" size="32px">fas fa-times</v-icon></v-btn>
                </v-col>
                <v-col cols="12" align="center" class="mb-5">
                    <h1 :style="responsiveTitulo" class="titulo">Newsletter</h1>
                </v-col>
                <v-form ref="form" v-model="valido" style="width:-webkit-fill-available!important;">
                  <v-col cols="12">
                      <v-text-field class="mt-2" solo v-model="usuario.nombre" :label="$t('Formularios.Nombre')" :hint="$t('Formularios.Nombre')" persistent-hint :rules="[v => !!v || $t('Formularios.NombreRequerido')]"/>
                      <v-text-field class="mt-2" solo v-model="usuario.email" :label="$t('Formularios.Email')" :hint="$t('Formularios.Email')" persistent-hint :rules="[v => !!v || $t('Formularios.EmailRequerido')]"/>
                      <v-text-field class="mt-2" solo v-model="usuario.ciudad" :label="$t('Formularios.Ciudad')" :hint="$t('Formularios.Ciudad')" persistent-hint :rules="[v => !!v || $t('Formularios.CiudadRequerido')]"/>
                  </v-col>
                  <v-col cols="12" align="center">
                    <div v-html="textoEs" v-if="getIdioma === 'es'" class="vietnam" style="font-size:18px"></div>
                    <div v-html="textoEn" v-else class="vietnam" style="font-size:18px"></div>
                    <v-btn color="black white--text" x-large style="min-width:20%!important" @click="suscribirme" :disabled="!valido">{{$t('Formularios.Suscribirme')}}</v-btn>
                  </v-col>
                </v-form>
            </v-row>
        </v-container>
    </v-dialog>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'
import * as faker from 'faker'
import axios from 'axios'
import firebase from 'firebase/app'
import 'firebase/firestore'
export default {
  name: 'Newsletter',
  data () {
    return {
      usuario: {
        nombre: null,
        email: null,
        ciudad: '',
        uid: faker.random.alphaNumeric(8),
        aprobado: false
      },
      imagen: '',
      textoEs: '',
      textoEn: '',
      valido: false
    }
  },
  mounted () {
    firebase.firestore().collection('utilidades').doc('newsletter').get().then(info => {
      this.imagen = info.data().imagen
      this.textoEs = info.data().textoEs
      this.textoEn = info.data().textoEn
    })
  },
  methods: {
    ...mapMutations(['setNewsletter', 'setAlerta', 'setTextoAlerta']),
    suscribirme () {
      firebase.firestore().collection('newsletter').where('email', '==', this.usuario.email).get().then(info => {
        if (info.docs.length === 0) {
          firebase.firestore().collection('newsletter').doc(this.usuario.uid).set(this.usuario).then(() => {
            axios({
              method: 'post',
              url: '/enviarcorreo',
              crossDomain: true,
              data: {
                destino: this.usuario.email,
                asunto: 'TrArtist Newsletter',
                texto: this.$i18n.t('Email.TextoNewsletter', {
                  nombre: this.usuario.nombre,
                  uid: this.usuario.uid })
              }
            })
              .then(response => {
                this.setAlerta()
                this.setTextoAlerta('Alerta.ConfirmarEmail')
              })
              .catch(error => {
                this.setAlerta()
                this.setTextoAlerta(error)
              })
          })
        } else {
          this.setAlerta()
          this.setTextoAlerta('Alerta.EmailRegistrado')
        }
      })
    }
  },
  computed: {
    ...mapGetters(['getNewsletter', 'getIdioma']),
    responsiveTitulo () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 'font-size:2rem;line-height:2rem;'
        case 'sm': return 'font-size:2rem;line-height:2rem;'
        case 'md': return 'font-size:3rem;line-height:3rem;'
        case 'lg': return 'font-size:4rem;line-height:3.5rem;'
        case 'xl': return 'font-size:4rem;line-height:3.5rem;'
        default: return 'font-size:4rem;line-height:3.5rem;'
      }
    }
  }
}
</script>

<style>
@media (max-width: 600px) {
  .v-dialog.news {
    max-width:80%!important;
  }
}
@media (min-width: 600px) and (max-width: 960px) {
  .v-dialog.news {
    max-height: 90%!important;
    max-width:70%!important;
  }
}
@media (min-width: 960px) and (max-width: 1264px) {
  .v-dialog.news {
    max-height: 90%!important;
    max-width:50%!important;
  }
}
@media (min-width: 1264px) {
  .v-dialog.news {
    max-height: 80%!important;
    max-width:40%!important;
  }
}
</style>
